module.exports = __webpack_public_path__ + "static/media/Group 740.15f60391.png";